import axios from 'axios';

const api = axios.create({
  baseURL: 'https://n8xdvo2m4a.execute-api.us-east-1.amazonaws.com/stage/ec2',
});

export default api;